// index.js
import './index.scss';
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Panel, TabPanel } from '@wordpress/components';

// Import the tab components
import FieldsTab from './components/FieldsTab';

const SettingsPage = () => {
    const tabs = [
        
       
        {
            name: 'FieldsTab',
            title: __('Fields', 'custom-fields-checkout-block-for-woocommerce'),
            content: <FieldsTab />,
        },
    ];

    return (
        <Panel>
            <TabPanel
                className="custom-fields-checkout-block-for-woocommerce-tabs"
                activeClass="active-tab"
                tabs={tabs}
            >
                {(tab, selected) => (
                    <div
                        className={`tab-content ${
                            tab.name === selected ? 'active-tab' : ''
                        }`}
                    >
                        {tab.content}
                    </div>
                )}
            </TabPanel>
        </Panel>
    );
};

domReady(() => {
    const root = createRoot(
        document.getElementById('custom-fields-checkout-block-for-woocommerce-settings')
    );
    root.render(<SettingsPage />);
});
